import moment from "moment";
// import { providerNoteSlice } from "app/modules/ProviderNote/_redux/providerNoteSlice";
import { shallowEqual, useSelector } from "react-redux";

export function parseResponse(res) {
  var response = null,
    data = null,
    meta = null,
    msg = "",
    code = -1;
  if (res.response) {
    response = res.response;
  } else if (res.data && res.data.response) {
    response = res.data.response;
  } else if (res.data && res.data.data) {
    response = res.data;
  } else if (res.isSuccess && res.data) {
    response = res;
    response.code = 0;
  }
  code = response?.code;
  msg = response?.msg || "";
  if (response?.code == 0 && response?.data) {
    data = response?.data || null;
    meta = response?.meta || null;
  }
  return { data, meta, msg, code };
}

export const compareObjects = (a, b) => {
  var equal = true;
  compareObjectsInDepth(a, b);
  function compareObjectsInDepth(a, b) {
    var keys1 = Object.keys(a);
    var keys2 = Object.keys(b);
    if (equal) {
      if (keys1.length == keys2.length) {
        keys1.forEach(function (key) {
          if (typeof a[key] == "object" && typeof b[key] == "object") {
            compareObjectsInDepth(a[key], b[key]);
          } else if (equal) {
            equal = a[key] == b[key];
          }
        });
      } else {
        equal = false;
      }
    }
  }
  return equal;
};

export const copyDeepObjects = (obj) => {
  if(obj && obj != ''){
    return JSON.parse(JSON.stringify(obj));
  }
  return null;
};

export const dataURItoFile = (dataURI, fileName) => {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(",")[1]);
  // separate out the mime component
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new File([ab], fileName, { type: mimeString });
};

export const roundToDecimals = (val, dig = 100) => {
  return Math.round(val * dig) / dig;
};

export const ceilToDecimals = (val, dig = 100) => {
  return Math.ceil(val * dig) / dig;
};

export const floorToDecimals = (val, dig = 100) => {
  return Math.floor(val * dig) / dig;
};

export const returnPracticeDate = (date) => {
  const { auth } = useSelector(
    ({ auth }) => ({
      auth,
    }),
    shallowEqual
  );

  return moment(date)?.tz(auth?.user?.practice?.timezone_long);
};

export function getCursorPosition(textInput) {
  var position = 0;
  if (document.selection) {
    // IE
    textInput.focus();
    var range = document.selection.createRange();
    range.moveStart("character", -textInput.value.length);
    position = range.text.length;
  } else if (textInput.selectionStart || textInput.selectionStart == "0") {
    // Other Browsers
    position = textInput.selectionStart;
  }
  return position;
}

export function removeSpecialCharacters(txt, replaceWith = '') {
  if(txt){
    return txt.replace(/[^a-z0-9]+/gi, replaceWith).toLowerCase();
  }
  return '';
}

export function waitTyping(callback) {
  let typing = true;
  setTimeout(() => {
    typing = false;
    if (!typing) {
      callback();
    }
  }, 400);
}

export function getParamString(params) {
  // console.log(params,'params')
  var paramString = "";
  if (params) {
    for (var p in params) {
      if (paramString == "") {
        paramString += "?";
      } else {
        paramString += "&";
      }
      paramString += p + "=" + params[p];
    }
  }
  return paramString;
}

export const compareDates = (from, to, diffUnit) => {
  let isBefore = true,
    diff = 0;
  if (from && to) {
    const momentFrom = moment(from);
    const momentTo = moment(to);
    isBefore = momentFrom.isSameOrBefore(momentTo);
    diff = momentTo.diff(momentFrom, diffUnit || "days");
  }
  return { isBefore, diff };
};

export const getItemClone = (item) => {
  const type = typeof item;
  if (type == "undefined" || item === null) {
    return null;
  }
  let clone;
  if (Array.isArray(item)) {
    clone = [];
    item.map((el) => {
      clone.push(getItemClone(el));
    });
  } else if (type == "object") {
    clone = {};
    Object.keys(item).map((itemKey) => {
      clone[itemKey] = getItemClone(item[itemKey]);
    });
  } else if (type == "string") {
    clone = "" + item;
  } else {
    clone = item;
  }
  return clone;
};

export const calculateFileSize = (size) => {
  var unit, pw;
  size = Number(size);
  if (size >= 1000) {
    pw = 0;
    while (size >= 1000) {
      size = size / 1000;
      pw++;
    }
    switch (pw) {
      case 1:
        unit = "KB";
        break;
      case 2:
        unit = "MB";
        break;
      case 3:
        unit = "GB";
        break;
      default:
        unit = "TB";
    }
  } else {
    unit = "bytes";
  }
  return Math.round(size * 10) / 10 + " " + unit + "-" + size;
};
// export const notify = (res, dispatch) => {
//   const { code, msg: serviceMsg } = parseResponse(res);
//   const { actions } = providerNoteSlice;
//   let type = "error",
//     msg = "";
//   if (res) {
//     if (res.isSuccess || code == 0) {
//       type = "success";
//     } else {
//       type = "error";
//     }
//     if (serviceMsg) {
//       msg = serviceMsg;
//     } else if (res.msg) {
//       msg = res.msg;
//     } else if (res.error) {
//       msg = res.error.msg || "";
//     } else {
//       msg = res.data && res.data.msg ? res.data.msg : "";
//     }
//   }
//   let notification = { open: true, type: type };
//   if (type == "success") {
//     notification.title = "Success";
//     notification.msg = msg || "Done Successfully.";
//   } else {
//     notification.title = "Failed";
//     notification.msg = msg || "Something went wrong.";
//   }
//   dispatch(actions.initNotificationDialog({ data: { ...notification } }));
// };
export const getListItemVal = (col, item) => {
  if(col.getVal){
      return col.getVal(item);
  }
  return item[col.key] || '';
}
export const getListItemValFunc = (col, item) => {
  if (col.getVal) {
    return col.getVal(item);
  }
  return item[col.key] || "";
};
export const getYearsList = () => {
  const end = new Date().getFullYear();
  const start = 1900;
  let year,
    years = [];
  for (year = end; year >= start; year--) {
    years.push(year);
  }
  return years;
};
export const getMonthsList = () => {
  let month,
    months = [];
  for (month = 1; month <= 12; month++) {
    if (month < 10) {
      month = "0" + month;
    }
    months.push("" + month);
  }
  return months;
};



export const formattedDate = (date, format = "MM/DD/YYYY") => {
  // "YYYY-MM-DD"
  const momentDate = moment(date).format(format);
  return moment(momentDate).isValid() ? momentDate : "";
};
export const changeTimeFormat = (time, format) => {
  //- changes time format only NOT date
  //------------ Params ------------
  //- time: hh:mm (02:44)
  //- format: required time format- moment ('hh:mm a')

  if (!format) {
    return;
  }

  let formattedTime;
  if (time.indexOf(" ") > -1) {
    formattedTime = moment(time, "hh:mm A").format(format);
  } else {
    formattedTime = moment(time, "HH:mm").format(format);
  }

  return moment(formattedTime, format).isValid() ? formattedTime : "";
};

export const isDateValid = (date, format = "MM/DD/yyyy") => {
  if (date) {
    const momentDate = moment(date);
    return momentDate.isValid() ? momentDate.format(format) : false;
  }
  return false;
};

export const trimString = (string, length, postDots = true) => {
  return string.length > length
    ? string.substring(0, length) + (postDots ? "..." : "")
    : string;
};

export const getFileUrl = (uuid) => {
  let url = "";
  url += process.env.REACT_APP_API_URL_V1 + "/notes/get_attachment.json";
  url += "?uuid=" + uuid || "";
  url += "&tz=" + String(new Date().getTimezoneOffset());
  return url;
};

export const printPdfDoc = (url) => {
  let w = window.open("", "Print");
  w.document.write("<html><head>");
  w.document.write("</head><body >");
  w.document.write(
    `<img id="print-image-element" src="${url}" style="object-fit: cover; max-height: 100%; max-width:100%;" />`
  );
  w.document.write(
    '<script>var img = document.getElementById("print-image-element"); img.addEventListener("load",function(){ console.log("image loaded!"); window.focus(); window.print(); window.document.close(); window.close(); }); </script>'
  );
  w.document.write("</body></html>");
};

export const formatAmount = (amount, skipSymbol) => {
  if (isNaN(amount)) {
    return "";
  }
  const symbol = skipSymbol ? "" : "$";
  return symbol + new Intl.NumberFormat("en-IN").format(amount);
};

export const getDataObjects = (data = {}, objKeys = [], dir = "get") => {
  const fn = {
    get: (key) => {
      if (data[key]) {
        data[key + "_obj"] = {
          id: data[key],
          name: data[key + "_name"] || "",
        };
      }
    },
    post: (key) => {
      const userObj = data[key + "_obj"];
      if (userObj) {
        data[key] = userObj.id;
        data[key + "_name"] = userObj.name;
      }
    },
  };
  objKeys.map((key) => {
    fn[dir](key);
  });
};

export const renderLineBreaks = txt => {
    return txt.replace(/\n/g, "<br />");
}
export const getTimeList = () => {
  let acpTimeArr = [];
  let i;
  for(i = 0; i < 76; i++){
      acpTimeArr.push({option_id: i, label: i});
  }
  return acpTimeArr;
}
export const getBaseUrl =()=>{
  return process.env.REACT_APP_API_URL_V1
}